import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./index.css";

const About = () => {
  const theme = useSelector((state) => state.theme);
  const textColor = theme === "LIGHT" ? "about-light" : "about-dark";
  const aboutDetailsTitle =
    theme === "LIGHT"
      ? "about-details-title-light"
      : "about-details-title-dark";

  return (
    <div className={`about ${textColor}`}>
      <h1 className="about-title">A little bit about me</h1>
      <p className="about-caption">Who I am and what I do.</p>
      <hr
        style={{
          background:
            theme === "LIGHT"
              ? "rgba(0, 0, 0, 0.10)"
              : "rgba(255, 255, 255, 0.10)",
          width: "100vw",
          position: "relative",
          left: "calc((100% - 100vw) / 2)",
        }}
      />
      <section className="about-details-section">
        <div className="about-image-container">
          <img
            src="https://res.cloudinary.com/ddaimmqrr/image/upload/v1696083831/Portfolio%20App/IMG_20190620_111411_b6apcg.jpg"
            alt="aboutProfile"
            className="about-profile-image"
          />
          <Link to="/contact">
            <button
              type="button"
              className="about-contact-button d-none d-md-flex"
            >
              <img
                src="https://res.cloudinary.com/ddaimmqrr/image/upload/v1696177552/Portfolio%20App/Send_t494gs.png"
                alt="send icon"
              />{" "}
              Get in Touch
            </button>
          </Link>
        </div>
        <div className="about-details-container">
          <p className={`about-details-title ${aboutDetailsTitle}`}>WHO I AM</p>
          <p className="about-details-caption">
            I’m Om Kumbhare a multi-disciplinary front-end developer based in
            Wardha, Maharashtra, &#127470;&#127475;. I'm having a Bachelor's
            degree in Civil Engineering with a deep passion for web development
            and software development.
          </p>
          <p className={`about-details-title ${aboutDetailsTitle}`}>
            WHAT I DO
          </p>
          <p className="about-details-caption">
            With one year of invaluable hands on experience in my Full Stack
            Developer Certification Program at NxtWave CCBP Intensive –– a tech
            company based here in Hyderabad. I have honed my skills in React.js,
            Node.js, Express.js, JavaScript, HTML, CSS, Python, SQL, SQLite and
            Java, allowing me to craft seamless and interactive user
            experiences. During my time at NxtWave, I had the privilege of
            collaborating on projects such as NxtWatch App, Jobby App,
            InstaShare App etc. It was an incredibly rewarding experience to
            develop applications, which help me strengthen my skillset.
          </p>
          <p className={`about-details-title ${aboutDetailsTitle}`}>
            WHAT I DID
          </p>
          <p className="about-details-caption">
            Before delving into the realm of front end engineering, I spent one
            and half year as a Civil Engineer. Amidst the challenges of
            Covid-19, I proactively enrolled in the NxtWave CCBP Intensive
            Certification course. My engineering background proved invaluable,
            enabling me to swiftly grasp diverse technologies and expand my
            knowledge. It has equipped me with a keen eye for aesthetics and a
            deep understanding of user interface and frontend tech. It enables
            me to seamlessly blend functionality and visual appeal in every
            project I undertake.
          </p>
          <p className="about-details-caption">
            Feel free to reach out via <u className={textColor}>E-mail</u>, or
            follow me on <u className={textColor}>Twitter</u>. Want to see where
            I’ve worked? Check out my <u className={textColor}>Resume</u>, or
            Connect with me on <u className={textColor}>LinkedIn</u>.
          </p>
          <p className="about-details-caption">Let’s build something great,</p>
          <p className="portfolio-signature">Om Kumbhare</p>
          <Link to="/contact">
            <button
              type="button"
              className="about-contact-button d-md-none mt-5"
            >
              <img
                src="https://res.cloudinary.com/ddaimmqrr/image/upload/v1696177552/Portfolio%20App/Send_t494gs.png"
                alt="send icon"
              />{" "}
              Get in Touch
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
